
import {  PostJobRoles} from "../apiconstants/constants";
import { useState, useEffect } from 'react';
import Axios from "axios";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import Tooltip from 'react-bootstrap/Tooltip';
import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import Swal from "sweetalert2";
import ConsultantLayout from "../commonlayouts/consultantlayout";
import { Link,useNavigate } from "react-router-dom";
import { useCountry } from "../contexts/countrycodecontext.js";

const AddJobRole = () => {
  const [isDisabled, setIsDisabled] = useState(false);
  var apiUrl = {};
  const { register, handleSubmit, setValue, formState,reset } = useForm();
  const { errors } = formState
  const { isSubmitting } = formState;
  const { selectedCountry} = useCountry();
  const navigate = useNavigate();
  let Guid="";
  const guid = localStorage.getItem("guid");
  const employerGuid = localStorage.getItem("employerGuid")
  const email = localStorage.getItem("email")
  const token = localStorage.getItem("jwtToken");
  const roleID = localStorage.getItem("roleID")
  
  if(roleID==3){
   Guid = employerGuid
  }
  else{
    Guid= guid
  }
  const onSubmit = (data, e) => {
    e.preventDefault();
    AddData(data);

  return new Promise(resolve => {
      setTimeout(() => {
        resolve();
      }, 5000);
    });
  }

  const AddData = async(data) => {
       const params={
        "jobRole": data.jobRole,
        "userGuid": Guid,
        "countryID":selectedCountry
      }
    apiUrl = PostJobRoles.APIURL;
    Axios.post(apiUrl, params, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${token}`,
      } })
      .then((result) => {
             if (result.data === 'Job role added successfully.') {
          // GetConsultantProfile();
        Swal.fire({
            position: 'center',
            icon: 'success',
            title: 'Added Successfully ',
            showConfirmButton: false,
            timer: 5000
          })
          navigate("/Employer/JobRoles")

          // toast.success('Data Saving', {autoClose:5000})

        }
       else if (result.data == 'Job role already exists.') {
          // GetConsultantProfile();
        Swal.fire({
            position: 'center',
            icon: 'warning',
            title: 'already exists. ',
            showConfirmButton: false,
            timer: 5000
          })
          // toast.success('Data Saving', {autoClose:5000})

        }

        else {
          // toast.error('Issue with data format', {autoClose:5000})
          Swal.fire({
            position: 'center',
            icon: 'error',
            title: 'Add correct Details',
            showConfirmButton: false,
            timer: 5000
          })
        }

      }).catch(
        function (error) {
          console.log("Error" + error)
        })

  }
  

  useEffect(() => {

  }, []);

  return (
    <ConsultantLayout>
      <section>
        <div className="container-fluid mt-4 pb-5">
          <div className='row'>
           <div className='col-sm-12 col-lg-6 col-xl-6 col-md-6  mt-3'>
           <div style={{ display: 'flex', alignItems: 'center' }}>
  <Link to="/Employer/JobRoles">
    <i className="fa fa-arrow-left" style={{ color: "#00a7ac", fontSize: 16, marginRight: '10px', marginTop: 8}} aria-hidden="true"></i>
  </Link>
  <h2 style={{ color: "#00a7ac", marginBottom: '0', marginTop: 8 }}>Add Job Role</h2>
</div>      </div>
     </div>
<hr/>
<div class="card shadow-lg mt-5 p-5" style={{border:"none"}}>
                        
                        <div class="row mt-2">
<form onSubmit={handleSubmit(onSubmit)} >
          <div className="row mt-2 p-0">
            <div className="col-sm-12 col-lg-6 col-xl-6 col-md-6 mt-3">
         
              <OverlayTrigger placement="bottom" overlay={(props) => (<Tooltip id="tooltip" {...props}> Job Role</Tooltip>)}>
                <input type="text" name="jobRole"  {...register("jobRole", { required: "Role Name Required" })} placeholder="Job Role" className={`form-control basic-form  ${errors.jobRole ? 'is-invalid' : ''}`} />
              </OverlayTrigger>
              <div className="invalid-feedback"> {errors.jobRole?.message}</div>
           
            </div>
           

          </div>
         
    
          <div className="row mt-4 p-0">
            <div className="col-12">
            <Link to="/Employer/JobRoles"> 
             <button  style={{float:"right"}}    disabled={isSubmitting || isDisabled} className="btn btn-primary ">
                  Cancel
                </button>
                </Link>
              <button style={{float:"right"}} disabled={isSubmitting || isDisabled} className="btn btn-primary mr-3">
                {isSubmitting && <span className="spinner-border spinner-border-sm mr-1"></span>}
                Save
              </button> &nbsp;&nbsp;&nbsp;
            </div>
        </div>
        </form>
        </div>
        </div>
                </div>
  </section>
    </ConsultantLayout>
  );
}

export default AddJobRole;